import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode, our Washington, DC team is here to listen, solve challenges, and provide dependable support that helps your business grow.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise",
        description: "At Mobikode, we build thoughtful digital solutions that help businesses across Washington, DC and beyond grow, adapt, and thrive.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "At Mobikode, we build tailored digital solutions that simplify your work, solve real challenges, and help your business grow.",
        image: "/assets/mumbai/img2.png"
    },
];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help financial businesses in Washington, DC work smarter, serve customers better, and grow with confidence through secure, reliable, and human-focused technology solutions.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help eCommerce businesses in Washington, DC grow through smart, reliable digital solutions that simplify operations, improve customer experiences, and drive lasting growth.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Washington, DC insurance companies simplify operations, enhance customer experiences, streamline claims and policy management, and grow confidently with secure, reliable digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help manufacturing businesses in Washington, DC work smarter with practical technology that streamlines operations, boosts productivity, and creates efficient processes built for sustainable growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we help retail and consumer brands in Washington, DC turn ideas into simple, smart digital experiences that delight customers, streamline everyday operations, and drive meaningful, lasting business growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Healthcare & Life Sciences organizations in Washington, DC use technology to improve patient care, streamline operations, and create simpler, more connected digital experiences.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "At Mobikode, we help media and communication businesses turn ideas into engaging digital experiences. By blending technology, creativity, and innovation, we simplify operations, connect audiences, and build brands people genuinely remember.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses in Washington, DC work smarter, streamline everyday operations, enhance delivery experiences, and grow with practical digital solutions built around real business needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help businesses in Washington, DC turn ideas into meaningful digital solutions, combining smart technology, creativity, and expertise to drive lasting growth.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we help nonprofits across Washington, DC use technology to reach more people, work smarter, and make a lasting difference in the communities they serve.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help professional service businesses in Washington, DC work smarter, simplify everyday processes, and deliver better client experiences through practical, reliable, and customized digital solutions.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Washington, DC real estate businesses work smarter with practical digital solutions that simplify operations, improve client experiences, and build stronger connections between agents, builders, and buyers.",
        image: "/assets/mumbai/item12.png"
    },
];

function Washington() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Washington DC | ITSM & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers ServiceNow consulting in Washington DC to help businesses streamline IT operations, automate workflows, integrate enterprise systems, and improve service management with scalable digital solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Washington DC, ServiceNow Consultant Washington DC, ServiceNow Implementation Washington DC, ServiceNow Integration Washington DC, ServiceNow ITSM Washington DC, ServiceNow Managed Services Washington DC, ServiceNow Automation Washington DC, ServiceNow Development Washington DC, ServiceNow Solutions Washington DC, ServiceNow Consulting Company Washington DC"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-melbourne"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Washington DC | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform service management with Mobikode's ServiceNow consulting solutions in Washington DC. Improve workflows, automate processes, connect business systems, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-washington-dc"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Washington DC | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Get tailored ServiceNow consulting solutions in Washington DC for IT service management, workflow automation, system integration, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/melbourne/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Washington DC" description="Partner with Mobikode’s ServiceNow experts in Washington DC to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/washington.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Washington DC
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Washington, DC to simplify everyday operations, automate workflows, empower your teams, and build smarter, more connected businesses.
                        </p>
                    </div>
                </div>
            </section> */}

            {/* <ServiceSection image={"/assets/mumbai/Melbourne.png"}
                text={"At Mobikode, we help businesses across Washington, DC get more from ServiceNow without making things complicated. From implementation and customization to seamless integrations and ongoing support, our team builds solutions around your real business needs. We streamline workflows, automate repetitive tasks, and improve employee experiences, helping your organization work smarter, scale confidently, and make meaningful progress in its digital transformation journey. "}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help businesses across Washington, DC simplify work with ServiceNow through practical consulting, smart automation, and tailored solutions that improve efficiency and create better digital experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Washington
